import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {IVisitedLocation} from '../../store';
import {IBaseResponse, WebService} from '../../services';
import {findIndex, pick} from 'lodash';
import {Vue} from 'vue-property-decorator';

interface ISimpleLineItem {
	id: string;
	name: string;
	optionsText: string;
}

interface ISimpleTicketFeedback {
	status: number;
	statusText: string;
	note: string;
}


interface ISimpleTicket {
	id: string;
	closedDate: number;
	location: IVisitedLocation;
	lineItems: ISimpleLineItem[];
	feedback: ISimpleTicketFeedback;
	pointsEarned: number;
}

export interface ISimpleTicketStoreState {
	latestTicketId: string | null;
	tickets: ISimpleTicket[];
}

/**
 * @deprecated
 */
@Module({name: 'tickets', namespaced: true})
class SimpleTicketModule extends VuexModule implements ISimpleTicketStoreState {
	latestTicketId: string | null = null;
	tickets: ISimpleTicket[] = [];

	public static mergeAndAdd(existingItems: ISimpleTicket[], newItems: ISimpleTicket[], predicateKeys: string[]) {
		newItems.forEach((newItem) => {
			const existingItemIndex = findIndex(existingItems, pick(newItem, predicateKeys));
			if(existingItemIndex > -1) {
				Vue.set(existingItems, existingItemIndex, Object.assign({}, existingItems[existingItemIndex], newItem));
			} else {
				existingItems.push(newItem);
			}
		});
	}

	get latestTicket() {
		if(!this.latestTicketId) {
			return null;
		}
		return this.tickets.find((ticket) => {
			return ticket.id === this.latestTicketId;
		}) || null;
	}

	@Action
	async fetchLatestTicket() {
		const response = await WebService.authenticatedClient.get<IBaseResponse<{ticket: ISimpleTicket}>>('/tickets/latest');
		this.addTicket(response.data.data.ticket);
		this.setLatestTicketId(response.data.data.ticket.id);
	}

	@Action
	async submitFeedback(payload: {locationId: string; ticketId: string; status: number; note: string}) {
		const response = await WebService.authenticatedClient.post<IBaseResponse<{ticket: ISimpleTicket}>>(`/locations/${payload.locationId}/tickets/${payload.ticketId}/feedback`, {
			status: payload.status,
			note: payload.note
		});
		this.addTicket(response.data.data.ticket);
	}

	@Mutation
	setLatestTicketId(id: string) {
		this.latestTicketId = id;
	}

	@Mutation
	clearLatestTicketId() {
		this.latestTicketId = null;
	}

	@Mutation
	public addTicket(ticket: ISimpleTicket) {
		SimpleTicketModule.mergeAndAdd(this.tickets, [ticket], ['id']);
	}

	@Mutation
	public removeTicket(ticketId: string) {
		const foundIndex = findIndex(this.tickets, {id: ticketId});
		if(foundIndex !== -1) {
			this.tickets.splice(foundIndex, 1);
		}
	}

	@Mutation
	public clearTickets() {
		this.tickets = [];
	}
}


/**
 * @deprecated
 */
export {
	SimpleTicketModule
};
